import { appService } from '@ibe/components';
import { ConfigModel, ConfigService, defaultConfig, fetchJSON, LoggerFactory } from '@ibe/services';
import { Currency, getLanguageFromTenant, Language } from '../Translations';
import { ThgConfigModel } from './ThgConfigModel';
import { customConfig } from './customConfig';
import { initAccountingAreaHeader } from './config';

const logger = LoggerFactory.get('minimal-config');
const DEFAULT_TENANT = Language.DE;

export const configService = new ConfigService<ConfigModel>(ConfigModel, defaultConfig);
configService.mergeIntoConfig(customConfig);

function initLanguage(initTenant?: string): void {
  const language = getLanguageFromTenant(initTenant);
  appService.setLang(language);
}

function initCurrency(): void {
  appService.setCurrency(Currency.EUR);
}

export const bootMinimal = async (
  configOverrides?: Partial<ConfigModel>,
  thgConfig?: ThgConfigModel
): Promise<boolean> => {
  if (configOverrides) {
    configService.mergeIntoConfig(configOverrides);
  }
  const url = configService.get().configUrl;
  let externalConfig = {};
  if (url) {
    externalConfig = (await fetchJSON(url)) as Partial<ConfigModel>;
  }
  configService.mergeIntoConfig(externalConfig);
  if (thgConfig) {
    configService.mergeIntoConfig(thgConfig);
  }
  const config = configService.get();
  logger.log('booting...');
  await appService.hydrate(config);

  initLanguage();
  initCurrency();
  initAccountingAreaHeader(appService, thgConfig);

  logger.log('App hydrated', appService.currency, appService.lang);
  return false;
};
